import request from '@/router/axios';
//查询资源列表(带分页)
export const searchResourcePage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/searchResourcePage',
    method: 'post',
    data: data
  })
}
// //查询配置资源树(组织资源配置、项目资源配置)
// export const searchConfigResourceTree = (data) => {
//   return request({
//     url: '/svolt-ess-boss-service/resource/searchConfigResourceTree',
//     method: 'post',
//     data: data
//   })
// }
//查询组织资源树
export const searchOrganizationResourceTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/searchOrganizationResourceTree',
    method: 'get',
    params: data
  })
}
//查询项目资源树
export const searchProjectResourceTreeV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/searchProjectResourceTreeV2',
    method: 'get',
    params: data
  })
}
//添加资源
export const addResource = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/addResource',
    method: 'post',
    data: data
  })
}
//添加资源配置(组织资源配置、项目资源配置)
export const addConfigResourceTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/addConfigResourceTree',
    method: 'post',
    data: data
  })
}

//删除资源
export const deleteResource = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/deleteResource',
    method: 'post',
    data: data
  })
}
//修改资源
export const updateResource = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/updateResource',
    method: 'post',
    data: data
  })
}

//查询全部资源列表
export const searchAllResources = (data) => {
  return request({
    url: '/svolt-ess-boss-service/resource/searchAllResources',
    method: 'post',
    data: data
  })
}

export default{
  searchResourcePage,
  // searchConfigResourceTree,
  searchOrganizationResourceTree,
  searchProjectResourceTreeV2,
  addResource,
  addConfigResourceTree,
  deleteResource,
  updateResource,
  searchAllResources
}



// WEBPACK FOOTER //
// ./src/api/resource.js